// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_show_cart = /** @type {(inputs: {}) => string} */ () => {
	return `View Cart`
};

const el_show_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Στο Καλάθι`
};

const ru_show_cart = /** @type {(inputs: {}) => string} */ () => {
	return `В корзину`
};

const he_show_cart = /** @type {(inputs: {}) => string} */ () => {
	return `לסל`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const show_cart = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.show_cart(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("show_cart", locale)
	if (locale === "en") return en_show_cart(inputs)
	if (locale === "el") return el_show_cart(inputs)
	if (locale === "ru") return ru_show_cart(inputs)
	if (locale === "he") return he_show_cart(inputs)
	return "show_cart"
};